// removed by extract-text-webpack-plugin
module.exports = {"navbar_dropdown":"navbar_dropdown","navbar_dropdown_wrapper":"navbar_dropdown_wrapper","dark":"dark"};


//////////////////
// WEBPACK FOOTER
// ./src/view/screens/Project/components/ProjectsDropdown/style.scss
// module id = 1354
// module chunks = 0